/**
 * LoginPage — DEPRECATED.
 *
 * The legacy standalone login page has been replaced by the homepage
 * OTP sign-in modal. This component only exists to safely redirect any
 * remaining links / bookmarks / 3rd-party references to `/login`
 * → `/?signin=1` so the existing-user Sign In modal auto-opens on the
 * new browse-first homepage. `replace` is used so the obsolete /login
 * URL is not retained in browser history.
 */
import { Navigate, useLocation } from "react-router-dom";

export default function LoginPage() {
  const location = useLocation();

  // Preserve `returnTo` if present so bookmarked deep-links still work.
  const params = new URLSearchParams(location.search);
  const returnTo = params.get("returnTo");
  const target = returnTo
    ? `/?signin=1&returnTo=${encodeURIComponent(returnTo)}`
    : "/?signin=1";

  return <Navigate to={target} replace />;
}
